import { DataGrid } from "@mui/x-data-grid";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import { Set_StockTransfer_HeadObject_Set } from "../SliceStockTransfer";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  vMediaQuery,
  //grid saleshistory end
  vRdxWmsHead,
  sDocLoadingGrnType,
  sType,
  sTax,
  sTransferType,
  fonSelectedGrnType,
  fGrnDate,
  fInvDate,
  fType,
  fTax,
  fTransferType,
  fFromLocation,
  fToLocation,
  fCreditLimit,
  fOsAmount,
  fAvlAmt,
  xKey,
  xFocusInput,
  sFromLocation,
  sToLocation,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  inputFocus,
  sBufferItmCd,
  headGridShow,
  sHeadGridColumn,
  sHeadGridRow,
  dispatch,
  fModalA_FromLoc,
  fModalA_ToLoc,
  fRefDocTypeOnChange = () => {},
  fRefDocType = () => {},
  fonChangeDo,
  fDropId,
  fModalDropId,
  //GC customer
  xonChangeInputCustomer,
  xhandleClick,
  xrowDropdownSearch,
  xcolumnsDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
  sOSDetailObj,
}) {
  return (
    <form id="WmsStockTransferHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          lg={5}
          className={vMediaQuery ? "" : "pe-5"}
        >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            {/* <Grid item xs={3} sm={2} md={4}  >
              <CmpTypographyField xcomponent={"span"} xText={"Transfer Type"} />
            </Grid> */}
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"1"}
                xLabelText="Doc Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpTextFieldV1
                xLabelText="Doc No"
                xSize="small"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpDatePickerField001V1
                xtabIndex={"2"}
                xLabelText="Ref Date"
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <GCToggleSearchV1
                xLabelText="DropId"
                xtabIndex={"101"}
                xName={"DropId"}
                xType={"text"}
                xValue={vRdxWmsHead?.DropId}
                xReadOnly={xDisableBasedOnGridDataLength}
                xOnChange={fDropId}
                xOnKeyUp={fModalDropId}
                xonClickbtn={fModalDropId}
                xError={xErrorMsg.DropId === "" ? false : true}
                xErrorMessage={xErrorMsg.DropId}
              />
            </Grid>
          </Grid>
        </Grid>
        {!headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(xErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              <Grid item xs={6} sm={4} md={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"14"}
                  xLabelText="Transfer Type"
                  xValue={vRdxWmsHead.TransferType}
                  xOnChange={fTransferType}
                  xName={"TransferType"}
                  xData={sTransferType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.TransferType === "" ? false : true}
                  xErrorMessage={xErrorMsg.TransferType}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>

              <Grid item xs={6} sm={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"5"}
                  xLabelText="From Loc"
                  xValue={vRdxWmsHead.A_FromLoc}
                  xOnChange={fFromLocation}
                  xName={"A_FromLoc"}
                  xData={sFromLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_FromLoc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_FromLoc}
                  xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                />
              </Grid>
              {/* <Grid item xs={9} sm={10} md={10} container>
                <Grid item xs={9} sm={10} md={3.5}>
                  <CmpSelectField
                    xtabIndex={"5"}
                    xLabelText="A_FromLocBr"
                    xValue={vRdxWmsHead.A_FromLocBr}
                    xOnChange={fFromLocation}
                    xName={"A_FromLocBr"}
                    xData={sFromLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={xErrorMsg.A_FromLocBr === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_FromLocBr}
                    xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                  />
                </Grid>
                <Grid item xs={3} sm={2} md={2.5}>
                  <CmpInputField
                    xtabIndex={"8"}
                    xValue={vRdxWmsHead.A_FromLocBatch}
                    xType={"text"} // text/number/password
                    xName={"A_FromLocBatch"}
                    xReadOnly={true}
                    xError={xErrorMsg.A_FromLocBatch === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_FromLocBatch}
                    // xOnKeyUp={(e) => {
                    //   xFocusInput("A_LocName");
                    // }}
                  />
                </Grid>
                <Grid item xs={12} sm={2} md={3.5}>
                  <GCToggleSearch
                    xtabIndex={"101"}
                    xName={"A_FromLoc"}
                    xType={"text"}
                    xValue={vRdxWmsHead?.A_FromLocName}
                    xReadOnly={false}
                    xOnChange={(e) => {
                      dispatch(
                        Set_StockTransfer_HeadObject_Set({
                          ...vRdxWmsHead,
                          A_FromLoc: "",
                          A_FromLocName: e.target.value,
                        })
                      );
                    }}
                    xOnKeyUp={fModalA_FromLoc}
                    xonClickbtn={fModalA_FromLoc}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid item xs={12} sm={10} md={2.5}>
                  <CmpInputField
                    xtabIndex={"6"}
                    xValue={vRdxWmsHead.A_FromLocTrn}
                    xType={"text"} // text/number/password
                    xName={"A_FromLocTrn"}
                    xReadOnly={true}
                    xError={xErrorMsg.A_FromLocTrn === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_FromLocTrn}
                    // xOnKeyUp={(e) => {
                    //   xFocusInput("A_LocName");
                    // }}
                  />
                </Grid>
              </Grid> */}

              <Grid item xs={6} sm={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"5"}
                  xLabelText="To Loc"
                  xValue={vRdxWmsHead.A_ToLoc}
                  xOnChange={fToLocation}
                  xName={"A_ToLoc"}
                  xData={sToLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_ToLoc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_ToLoc}
                  xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                />
              </Grid>
              {/* <Grid item xs={9} sm={10} md={10} container>
                <Grid item xs={9} sm={10} md={3.5}>
                  <CmpSelectField
                    xtabIndex={"5"}
                    xLabelText="A_ToLocBr"
                    xValue={vRdxWmsHead.A_ToLocBr}
                    xOnChange={fToLocation}
                    xName={"A_ToLocBr"}
                    xData={sToLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={xErrorMsg.A_ToLocBr === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_ToLocBr}
                    xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                  />
                </Grid>
                <Grid item xs={3} sm={2} md={2.5}>
                  <CmpInputField
                    xtabIndex={"8"}
                    xValue={vRdxWmsHead.A_ToLocBatch}
                    xType={"text"} // text/number/password
                    xName={"A_ToLocBatch"}
                    xReadOnly={true}
                    xError={xErrorMsg.A_ToLocBatch === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_ToLocBatch}
                    // xOnKeyUp={(e) => {
                    //   xFocusInput("A_LocName");
                    // }}
                  />
                </Grid>
                <Grid item xs={12} sm={2} md={3.5}>
                  <GCToggleSearch
                    xtabIndex={"101"}
                    xName={"A_ToLoc"}
                    xType={"text"}
                    xValue={vRdxWmsHead?.A_ToLocName}
                    xReadOnly={false}
                    xOnChange={(e) => {
                      dispatch(
                        Set_StockTransfer_HeadObject_Set({
                          ...vRdxWmsHead,
                          A_ToLoc: "",
                          A_ToLocName: e.target.value,
                        })
                      );
                    }}
                    xOnKeyUp={fModalA_ToLoc}
                    xonClickbtn={fModalA_ToLoc}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid item xs={12} sm={10} md={2.5}>
                  <CmpInputField
                    xtabIndex={"6"}
                    xValue={vRdxWmsHead.A_ToLocTrn}
                    xType={"text"} // text/number/password
                    xName={"A_ToLocTrn"}
                    xReadOnly={true}
                    xError={xErrorMsg.A_ToLocTrn === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_ToLocTrn}
                    // xOnKeyUp={(e) => {
                    //   xFocusInput("A_LocName");
                    // }}
                  />
                </Grid>
              </Grid> */}

              <Grid item xs={12} sm={11} md={11} container spacing={0.9}>
                <Grid item xs={3} sm={2} md={2}>
                  <CmpTextFieldV1
                    xLabelText="Ref.Typ"
                    xSize="small"
                    xValue={vRdxWmsHead.A_RefDocCd}
                    xType={"text"} // text/number/password
                    xName={"A_RefDocCd"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={xErrorMsg.A_RefDocCd === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_RefDocCd}
                    xOnKeyUp={xKey}
                  />
                </Grid>
                <Grid item xs={3} sm={6} md={6}>
                  <CmpTextFieldV1
                    xLabelText="Ref.Name"
                    xSize="small"
                    xValue={vRdxWmsHead.A_RefDocName}
                    xType={"text"} // text/number/password
                    xName={"A_RefDocName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={xErrorMsg.A_RefDocName === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_RefDocName}
                    xOnKeyUp={xKey}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                  <GCToggleSearchV1
                    xLabelText="RefDocNo"
                    xtabIndex={"101"}
                    xName={"A_RefDocType"}
                    xType={"text"}
                    xValue={vRdxWmsHead?.A_RefDocType}
                    xReadOnly={false}
                    xOnChange={(e) => {
                      fRefDocTypeOnChange(e);
                    }}
                    xOnKeyUp={fRefDocType}
                    xonClickbtn={fRefDocType}
                    xError={xErrorMsg.A_RefDocType === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_RefDocType}
                  />
                </Grid>
              </Grid>

              {false && (
                <>
                  <Grid item xs={3} sm={2} md={2} lg={2}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Customer"}
                    />
                  </Grid>

                  <Grid item xs={9} sm={10} md={10} lg={10}>
                    <Grid container spacing={0}>
                      <Grid item xs={3} sm={2} md={2} lg={2}>
                        <CmpInputField
                          xValue={vRdxWmsHead.A_Party}
                          xType={"text"} // text/number/password
                          xName={"A_Party"}
                          xReadOnly={true}
                          xOnChange={""}
                          xError={xErrorMsg.A_Party === "" ? false : true}
                          xErrorMessage={xErrorMsg.A_Party}
                        />
                      </Grid>
                      <Grid item xs={9} sm={10} md={10} lg={10}>
                        <GCToggleSearch
                          xName={"A_PartyName"}
                          xType={"text"}
                          xValue={vRdxWmsHead.A_PartyName}
                          xReadOnly={false}
                          xOnChange={(e) => {
                            xonChangeInputCustomer(e);
                          }} //GCToggleSearch onchange main input
                          xOnKeyUp={(e) => {
                            xhandleClick(e, "customer");
                          }} //GCToggleSearch xOnKeyUp main input
                          xError={xErrorMsg.A_PartyName === "" ? false : true}
                          xErrorMessage={xErrorMsg.A_PartyName}
                          xMediaQuery={false}
                          xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                          xrows={xrowDropdownSearch} //GCToggleSearch-grid
                          xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                          xRowCellClick={xOnCellKeyDown}
                          xRowClick={xOnRowClick}
                          xToggle={xToggleDropdown} //GCToggleSearch- true/false
                          xData={xData} //GCToggleSearch-select
                          xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                          xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                          xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                          xtabIndex="5"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}

              {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"CreditLimit"} />
            </Grid>
            <Grid item xs={9} sm={4} md={4} lg={4}>
              <CmpInputField
                xtabIndex={"10"}
                xValue={vRdxWmsHead.CreditLimit}
                xType={"number"} // text/number/password
                xName={"CreditLimit"}
                xReadOnly={true}
                xOnChange={fCreditLimit}
                xError={xErrorMsg.CreditLimit === "" ? false : true}
                xErrorMessage={xErrorMsg.CreditLimit}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"OsAmount"} />
            </Grid>
            <Grid item xs={9} sm={4} md={1} lg={1}>
              <CmpInputField
                xtabIndex={"11"}
                xValue={vRdxWmsHead.OsAmount}
                xType={"number"} // text/number/password
                xName={"OsAmount"}
                xReadOnly={true}
                xOnChange={fOsAmount}
                xError={xErrorMsg.OsAmount === "" ? false : true}
                xErrorMessage={xErrorMsg.OsAmount}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            <Grid item xs={3} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"span"} xText={"Avl.Amt"} />
            </Grid>
            <Grid item xs={9} sm={4} md={2} lg={2}>
              <CmpInputField
                xtabIndex={"12"}
                xValue={vRdxWmsHead.AvlAmt}
                xType={"number"} // text/number/password
                xName={"AvlAmt"}
                xReadOnly={true}
                xOnChange={fAvlAmt}
                xError={xErrorMsg.AvlAmt === "" ? false : true}
                xErrorMessage={xErrorMsg.AvlAmt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid> */}

              {/* <Grid item xs={3} sm={2} md={2} >
                <CmpTypographyField xcomponent={"span"} xText={"Tax"} />
              </Grid>
              <Grid item xs={9} sm={3} md={3} >
                <CmpSelectField
                  xtabIndex={"13"}
                  xLabelText="Tax"
                  xValue={vRdxWmsHead.TaxType}
                  xOnChange={fTax}
                  xName={"TaxType"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.TaxType === "" ? false : true}
                  xErrorMessage={xErrorMsg.TaxType}
                  xDisable={true}
                />
              </Grid> */}

              <Grid item xs={2} sm={1} md={1}>
                <CmpCheckboxField
                  xChecked={vRdxWmsHead.A_Do == "Y"}
                  xOnChange={fonChangeDo}
                  // xDisabled={vRdxWmsHead?.Batch?.toUpperCase() == "BATCH : NO"}
                  xDisabled={xDisableBasedOnGridDataLength}
                  xName={"DO"}
                  xNameField={"DO"}
                  xError={xErrorMsg.A_Do === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Do}
                  sales_onvoice_check_box="start"
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <div style={{ height: "150px", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sHeadGridRow}
                columns={sHeadGridColumn}
                onRowClick={() => {}}
                hideFooter={sHeadGridRow.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
